"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreen = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Spinner_1 = require("./Spinner");
var FULL_SCREEN_CLASS = "h-screen w-screen flex";
var FullScreen = function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: FULL_SCREEN_CLASS }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { size: "4x", className: "m-auto" }, void 0) }), void 0)); };
exports.FullScreen = FullScreen;
